import { API_PATH_INTERNAL, REFERRAL_APPROVAL_STATUS } from '@/lib/constants'
import apiService from '@/lib/services/apiService'
import {
  CreatePanelRequestRequest,
  UpdatePanelRequestStatusRequest,
} from '@/types/requests/panel-requests'
import {
  PanelRequestCollection,
  PanelRequestCollectionItem,
} from '@/types/responses/panel-requests'

class PanelRequestService {
  private endpoint = `${API_PATH_INTERNAL}/panel-requests`

  async getPanelRequests(params: {
    fromCompany?: number
    page?: number
    pageSize?: number
  }): Promise<PanelRequestCollection> {
    const response = await apiService.get(this.endpoint, {
      params: {
        order: REFERRAL_APPROVAL_STATUS.pending,
        ...params,
      },
    })

    return response.data
  }

  async createPanelRequest(
    request: CreatePanelRequestRequest,
  ): Promise<PanelRequestCollectionItem> {
    const response = await apiService.post(this.endpoint, request)
    return response.data
  }

  async updateReferralApprovalStatus(
    panelId: number,
    request: UpdatePanelRequestStatusRequest,
  ) {
    const response = await apiService.patch(
      `${this.endpoint}/${panelId}/update-approval-status`,
      request,
    )

    return response.data
  }
}

const panelRequestService = new PanelRequestService()

export default panelRequestService
